var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.49 27.235h-4.474l-2.053-.733-2.053.66H7.437c-3.666 0-6.672-3.006-6.672-6.673V7.437C.765 3.771 3.77.765 7.437.765H20.49c3.667 0 6.673 3.006 6.673 6.672V20.49c.073 3.74-2.933 6.746-6.673 6.746Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91 11.104v2.86h-3.3v3.739h3.3v9.459h4.106v-9.386h3.08l.587-3.74H16.09v-2.42c0-1.026.513-2.052 2.126-2.052h1.613v-3.3s-1.466-.22-2.933-.22c-3.006 0-4.986 1.76-4.986 5.06Z",
    fill: "#0084F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.765 .765)",
    d: "M0 0h26.471v26.471H0z"
  })))));
};

export default SvgFacebook;